import {PHOTOS_URL} from "../constants"

function Footer() {
    return (
      <div id="footer">
        <div className="logo">
            <img style={{paddingTop:"20px"}} src={`${PHOTOS_URL}logo-white.png`} alt="Cocunat" />
        </div>
        <div>
        <p style={{color:"#fff"}}>© 2022 Cocunat. All Rights Reserved</p>

        </div>
      </div>
    );
}
export default Footer;
  